import _ from "lodash";
import { CANVAS_IDS } from "./KonvaConstants";
import { TRANFORMER_CONFIG } from "./KonvaConfig";

/**
 *
 * @param {*} container
 * @returns Props for konva stage
 */
export const getStageProps = container => {
  const canvasRect = container.getBoundingClientRect();

  // * To prevent error of drawing 0 size canvas
  if (
    !canvasRect ||
    _.get(canvasRect, "width", 0) === 0 ||
    _.get(canvasRect, "height", 0) === 0
  ) {
    return null;
  }

  return {
    container,
    width: _.get(canvasRect, "width", 0),
    height: _.get(canvasRect, "height", 0),
  };
};

/**
 *
 * @returns Props for shape tranformer
 */
export const getTransformerProps = () => {
  return {
    id: CANVAS_IDS.TRANSFORMER_ID,
    anchorStyleFunc: anchor => {
      anchor.cornerRadius(TRANFORMER_CONFIG.ANCHOR_SIZE);
      anchor.width(TRANFORMER_CONFIG.ANCHOR_SIZE);
      anchor.height(TRANFORMER_CONFIG.ANCHOR_SIZE);
    },
    borderWidth: TRANFORMER_CONFIG.BORDER_WIDTH,
    anchorStroke: TRANFORMER_CONFIG.STROKE,
    anchorFill: TRANFORMER_CONFIG.ANCHORFILL,
    borderStroke: TRANFORMER_CONFIG.STROKE,
    flipEnabled: false,
    rotateEnabled: false,
    padding: 1,
    visible: true,
  };
};
